import { getImgUrl } from '@/api/getFile'
import { investigationPaperAnswerAnalysisFIll } from '@/api/investigationPaper.js'

// 数组扁平化
export function flatten(arr) {
  return arr.reduce((acc, val) => {
    return Array.isArray(val)
      ? acc.concat(flatten(val)) // 如果值是数组，递归处理其元素
      : acc.concat(val) // 如果值不是数组，直接添加到结果数组中
  }, [])
}

// 处理问卷问题
export function handlePollQuestion(arr) {
  return arr.map(ele => {
    const optionArr = []
    for (let i = 0; i < 5; i++) {
      var str = 'A'
      const res = String.fromCharCode(str.charCodeAt() + i)
      if (ele[`option${res}Title`] !== null) {
        optionArr.push({
          content: ele[`option${res}Title`],
          fileList: ele[`option${res}Image`] ? [{ name: ele[`option${res}Image`] }] : [],
          visitUrl: ele[`option${res}Image`],
          url: ele[`option${res}Image`] ? getImgUrl(ele[`option${res}Image`]) : '',
          isSupplement: ele[`is${res}Supplement`] === 1,
        })
      }
    }
    const checkedLists = []
    if (ele.imageFileAllow === 1) checkedLists.push(1)
    if (ele.videoFileAllow === 1) checkedLists.push(2)
    if (ele.textFileAllow === 1) checkedLists.push(3)
    if (ele.zipFileAllow === 1) checkedLists.push(1)
    return {
      questionId: ele.id || ele.questionId,
      questionTitle: ele.questionTitle,
      questionType: ele.questionType,
      option: optionArr,
      imageFileAllow: ele.imageFileAllow || 0,
      textFileAllow: ele.textFileAllow || 0,
      videoFileAllow: ele.videoFileAllow || 0,
      zipFileAllow: ele.zipFileAllow || 0,
      checkedLists,
    }
  })
}

// 处理问卷分析数据
export async function handlePollAnalysis(arr, id) {
  return await Promise.all(
    arr.map(async (ele, index) => {
      const optionArr = []
      for (let i = 0; i < 5; i++) {
        var str = 'A'
        const res = String.fromCharCode(str.charCodeAt() + i)
        if (ele[`option${res}Title`] !== null) {
          optionArr.push({
            content: ele[`option${res}Title`],
            url: ele[`option${res}Image`] ? getImgUrl(ele[`option${res}Image`]) : '',
            isSupplement: ele[`is${res}Supplement`] === 1,
            total: parseInt(ele[`option${res}Total`]),
            questionAnswerDetailList: ele.questionAnswerDetailList,
            star: ele.starQuestionStatisticLists ? ele.starQuestionStatisticLists[res] : '',
            code: res,
          })
        }
      }
      let obj = {}

      if (ele.questionType === 4 || ele.questionType === 5) {
        await investigationPaperAnswerAnalysisFIll({
          pageNo: 1,
          pageSize: 5,
          paperId: id,
          questionId: ele.id || ele.questionId,
        }).then(res => {
          obj = {
            list: res.data.investigationAnswerDTOList,
            total: parseInt(res.data.totalNumber),
          }
        })
      }
      return {
        ...obj,
        questionId: ele.id || ele.questionId,
        questionTitle: ele.questionTitle,
        questionType: ele.questionType,
        option: optionArr,
        imageFileAllow: ele.imageFileAllow || 0,
        textFileAllow: ele.textFileAllow || 0,
        videoFileAllow: ele.videoFileAllow || 0,
        zipFileAllow: ele.zipFileAllow || 0,
      }
    })
  )
}

// 下载文件
export function downloadFiles(res, fileName, suffix) {
  const disposition = res.headers['content-disposition'].replace(/\;/g, '')
  const headerFileName = decodeURIComponent(disposition.substring(disposition.indexOf('=') + 1), 'UTF-8')
  const suffixName = headerFileName.replace(/\"/g, '').split('.')[1]
  const link = document.createElement('a')
  const blob = new Blob([res.data], { type: res.data.type })
  link.style.display = 'none'
  link.href = URL.createObjectURL(blob)
  link.setAttribute('download', `${fileName}.${suffix || suffixName}`)
  document.body.appendChild(link)
  link.click()
  URL.revokeObjectURL(link.href)
  document.body.removeChild(link)
}

// 获取一周前的日期
export function setDate() {
  const time = new Date().getTime() - 6 * 24 * 60 * 60 * 1000
  const targetTime = `${new Date(time).getFullYear()}-${new Date(time).getMonth() > 9 ? new Date(time).getMonth() + 1 : `0${new Date(time).getMonth() + 1}`}-${
    new Date(time).getDate() > 9 ? new Date(time).getDate() : `0${new Date(time).getDate()}`
  }`

  return `${targetTime} ` + `00:00:00`
}

// 随机生成RGBA颜色
export function randomRgbaColor(alpha) {
  // `#${Math.random().toString(16).slice(2, 8).padEnd(6, '0')}`
  var r = Math.floor(Math.random() * 256) // 随机生成256以内r值
  var g = Math.floor(Math.random() * 256) // 随机生成256以内g值
  var b = Math.floor(Math.random() * 256) // 随机生成256以内b值
  return `rgba(${r},${g},${b},${alpha})` // 返回rgba(r,g,b,a)格式颜色
}

// 获取一周的日期
export function periodDate() {
  return (
    new Date().getFullYear() +
    '-' +
    (new Date().getMonth() > 9 ? new Date().getMonth() + 1 : '0' + (new Date().getMonth() + 1)) +
    '-' +
    (new Date().getDate() > 9 ? new Date().getDate() : '0' + new Date().getDate()) +
    ' ' +
    '00:00:00'
  )
}

/**
 * 判断是否是手机端，如果是，返回true
 * @returns Boolean
 */
export function isMobile() {
  // Android|webOS|iPhone|iPod|BlackBerry
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  )
  return flag
}
